import { lazy } from 'react';

// Single source of truth for the public, no-login SEO pages: path -> dynamic
// importer. Used LAZILY by the client router (App.js) and EAGERLY by the
// build-time static-HTML generator (scripts/prerender-ssg.js) so both stay in sync.
export const PUBLIC_TOOL_MODULES = {
  '/health-calculators': () => import('./PublicToolsIndex'),
  '/health-guides': () => import('./GuidesHubPage'),
  '/bmi-calculator': () => import('./BmiCalculatorPage'),
  '/calorie-calculator': () => import('./CalorieCalculatorPage'),
  '/ideal-weight-calculator': () => import('./IdealWeightCalculatorPage'),
  '/waist-to-height-ratio-calculator': () => import('./WaistToHeightCalculatorPage'),
  '/body-fat-calculator': () => import('./BodyFatCalculatorPage'),
  '/bmr-calculator': () => import('./BmrCalculatorPage'),
  '/macro-calculator': () => import('./MacroCalculatorPage'),
  '/healthy-age-calculator': () => import('./HealthyAgeCalculatorPage'),
  '/blood-pressure-checker': () => import('./BloodPressureCheckerPage'),
  '/cholesterol-ratio-calculator': () => import('./CholesterolRatioCalculatorPage'),
  '/heart-rate-zone-calculator': () => import('./HeartRateZoneCalculatorPage'),
  '/water-intake-calculator': () => import('./WaterIntakeCalculatorPage'),
  '/caffeine-calculator': () => import('./CaffeineCalculatorPage'),
  '/alcohol-unit-calculator': () => import('./AlcoholUnitCalculatorPage'),
  '/ovulation-calculator': () => import('./OvulationCalculatorPage'),
  '/child-growth-percentile-calculator': () => import('./ChildGrowthPercentileCalculatorPage'),
  '/child-bmi-calculator': () => import('./ChildBmiCalculatorPage'),
  '/baby-weight-percentile-calculator': () => import('./BabyWeightPercentilePage'),
  '/baby-height-percentile-calculator': () => import('./BabyHeightPercentilePage'),
  '/baby-head-circumference-calculator': () => import('./BabyHeadCircumferenceCalculatorPage'),
  '/child-height-predictor': () => import('./ChildHeightPredictorPage'),

  // Blood sugar / metabolic
  '/blood-sugar-converter': () => import('./BloodSugarConverterPage'),
  '/hba1c-calculator': () => import('./Hba1cCalculatorPage'),
  '/diabetes-risk-checker': () => import('./DiabetesRiskCheckerPage'),

  // Women's health
  '/period-calculator': () => import('./PeriodCalculatorPage'),
  '/due-date-calculator': () => import('./DueDateCalculatorPage'),
  '/pregnancy-weight-gain-calculator': () => import('./PregnancyWeightGainCalculatorPage'),

  // Category / authority hubs
  '/childrens-health': () => import('./ChildrensHealthHubPage'),
  '/womens-health': () => import('./WomensHealthHubPage'),
  '/heart-health': () => import('./HeartHealthHubPage'),
  '/weight-and-body': () => import('./WeightAndBodyHubPage'),

  // Supporting articles (question intent → funnel to a calculator)
  '/what-is-a-healthy-bmi': () => import('./WhatIsAHealthyBmiArticle'),
  '/what-is-normal-blood-pressure': () => import('./WhatIsNormalBloodPressureArticle'),
  '/what-does-140-90-blood-pressure-mean': () => import('./What14090MeansArticle'),
  '/how-much-water-should-i-drink': () => import('./HowMuchWaterArticle'),
  '/how-many-calories-to-lose-weight': () => import('./HowManyCaloriesToLoseWeightArticle'),
  '/blood-pressure-chart-by-age': () => import('./BloodPressureChartByAgeArticle'),
  '/how-to-measure-blood-pressure-at-home': () => import('./HowToMeasureBloodPressureArticle'),
  '/type-2-diabetes-symptoms': () => import('./Type2DiabetesSymptomsArticle'),

  // Answer articles — batch 2
  '/how-to-lower-blood-sugar': () => import('./HowToLowerBloodSugarArticle'),
  '/what-is-a-good-resting-heart-rate': () => import('./RestingHeartRateArticle'),
  '/how-to-lose-belly-fat': () => import('./HowToLoseBellyFatArticle'),
  '/how-much-protein-per-day': () => import('./HowMuchProteinArticle'),
  '/what-is-a-good-body-fat-percentage': () => import('./BodyFatPercentageArticle'),
  '/how-many-units-of-alcohol-a-week': () => import('./AlcoholUnitsPerWeekArticle'),
  '/early-signs-of-pregnancy': () => import('./EarlySignsOfPregnancyArticle'),
  '/is-my-baby-a-healthy-weight': () => import('./BabyHealthyWeightArticle'),

  // Answer articles — batch 3 (heart, metabolic, weight, fitness)
  '/signs-of-high-blood-pressure': () => import('./SignsOfHighBloodPressureArticle'),
  '/how-to-lower-blood-pressure': () => import('./HowToLowerBloodPressureArticle'),
  '/how-to-lower-cholesterol': () => import('./HowToLowerCholesterolArticle'),
  '/how-to-calculate-bmi': () => import('./HowToCalculateBmiArticle'),
  '/what-is-a-healthy-waist-size': () => import('./HealthyWaistSizeArticle'),
  '/how-to-boost-metabolism': () => import('./HowToBoostMetabolismArticle'),
  '/normal-blood-sugar-levels': () => import('./NormalBloodSugarLevelsArticle'),
  '/what-are-heart-rate-zones': () => import('./HeartRateZonesArticle'),
  '/what-is-a-good-ldl-level': () => import('./GoodLdlLevelArticle'),
  '/foods-that-raise-cholesterol': () => import('./FoodsThatRaiseCholesterolArticle'),
  '/hdl-vs-ldl-cholesterol': () => import('./HdlVsLdlArticle'),
  '/what-causes-high-cholesterol': () => import('./WhatCausesHighCholesterolArticle'),
  '/cholesterol-chart-by-age': () => import('./CholesterolChartByAgeArticle'),
};

export const PUBLIC_TOOL_ROUTES = Object.entries(PUBLIC_TOOL_MODULES).map(
  ([path, importer]) => ({ path, Component: lazy(importer) })
);
